import React from 'react';
import {
  Modal,
  ModalOverlay,
  ModalHeader,
  ModalCloseButton,
  ModalBody,
  ModalFooter,
  Button,
  Text,
} from '@chakra-ui/react';
import AdminModalContent from '../layout/AdminModalContent';
import {
  dangerButtonProps,
  primaryButtonProps,
  secondaryButtonProps,
  successButtonProps,
  warningButtonProps,
} from '../../theme/adminUi';

const CONFIRM_BUTTON_PROPS = {
  primary: primaryButtonProps,
  danger: dangerButtonProps,
  warning: warningButtonProps,
  success: successButtonProps,
};

/** Por encima del modal de agenda (~1400) cuando se abre anidado. */
const NESTED_MODAL_Z = 2000;

const ConfirmModal = ({
  isOpen,
  onClose,
  onConfirm,
  header,
  message,
  confirmLabel = 'Continuar',
  cancelLabel = 'Cancelar',
  confirmVariant = 'primary',
  isLoading = false,
  /** Acción extra (ej. Guardar y cerrar) a la derecha del confirm. */
  onSaveAndClose,
  saveAndCloseLabel = 'Guardar y cerrar',
  isSaveAndCloseLoading = false,
  /** Si true, sube el z-index para quedar por encima de otro Modal abierto. */
  nested = false,
  zIndex,
  closeOnEsc = true,
}) => {
  const confirmProps = CONFIRM_BUTTON_PROPS[confirmVariant] || primaryButtonProps;
  const stackZ = zIndex ?? (nested ? NESTED_MODAL_Z : undefined);
  const busy = isLoading || isSaveAndCloseLoading;

  return (
    <Modal
      isOpen={isOpen}
      onClose={onClose}
      isCentered
      blockScrollOnMount={false}
      trapFocus
      closeOnEsc={closeOnEsc}
      closeOnOverlayClick={false}
    >
      <ModalOverlay zIndex={stackZ} />
      <AdminModalContent
        containerProps={
          stackZ != null
            ? { zIndex: stackZ, pointerEvents: 'auto' }
            : undefined
        }
      >
        <ModalHeader fontSize="md">{header}</ModalHeader>
        <ModalCloseButton />
        <ModalBody>
          {typeof message === 'string' ? (
            <Text fontSize="sm" color="gray.700">
              {message}
            </Text>
          ) : (
            message
          )}
        </ModalBody>
        <ModalFooter gap={2} flexWrap="wrap">
          {cancelLabel ? (
            <Button
              {...secondaryButtonProps}
              onClick={onClose}
              isDisabled={busy}
            >
              {cancelLabel}
            </Button>
          ) : null}
          <Button {...confirmProps} onClick={onConfirm} isLoading={isLoading} isDisabled={busy}>
            {confirmLabel}
          </Button>
          {typeof onSaveAndClose === 'function' && (
            <Button
              {...primaryButtonProps}
              onClick={onSaveAndClose}
              isLoading={isSaveAndCloseLoading}
              isDisabled={busy}
            >
              {saveAndCloseLabel}
            </Button>
          )}
        </ModalFooter>
      </AdminModalContent>
    </Modal>
  );
};

export default ConfirmModal;
